import Vue from 'vue'
import Router from 'vue-router'

var jwt = require('jsonwebtoken')
//const secret = "ropels3cr3t"

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const PersCalendar = () => import('@/views/PersCalendar')
const ChangeCalendar = () => import('@/views/ChangeCalendar')
const Registro = () => import('@/views/Registro')
const RegistroArgomenti = () => import('@/views/RegistroArgomenti')
const Messaggi = () => import('@/views/Messaggi')
const ModRel = () => import('@/views/ModRel')
const IFrame = () => import('@/views/IFrame')
const PuntiPat = () => import('@/views/PuntiPat')
const ShowModRel = () => import('@/views/ShowModRel')
const Avvisi = () => import('@/views/Avvisi')
const Pagella = () => import('@/views/Pagella')
const RegistroPers = () => import('@/views/RegistroPers')
const PagellaHelp = () => import('@/views/PagellaHelp')
const Promemoria = () => import('@/views/Promemoria')
const DaGiustificare = () => import('@/views/DaGiustificare')
const Login = () => import('@/views/pages/Login')
const ChgPass = () => import('@/views/pages/ChgPass')

Vue.use(Router)

console.log("DBG2:", window.location.hostname, window.baseurl)

var router = new Router({
    mode: 'hash', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: [ // Attenzione: qui definisco tutto, poi le voci da mostrare arrivano dalle API
        {
            path: '/',
            redirect: '/dashboard',
            name: 'Home',
            component: DefaultContainer,
            children: [{
                path: 'dashboard',
                name: 'Dashboard',
                component: Dashboard,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'showcalpers',
                name: 'Calendario',
                component: PersCalendar,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'editcalpers',
                name: 'Edit Cal',
                component: ChangeCalendar,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'registro',
                name: 'Registro',
                component: Registro,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'registroarg',
                name: 'RegistroArgomenti',
                component: RegistroArgomenti,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'messaggi',
                name: 'Messaggi',
                component: Messaggi,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'modrel',
                name: 'ModRel',
                component: ModRel,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'filemanager',
                name: 'Lim',
                component: IFrame,
                meta: {
                    requiresAuth: true
                },
                props: {
                    src: '/File-Manager/index.php'
                }
            },
            {
                path: 'showavvisipers',
                name: 'Avvisi',
                component: Avvisi,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'showmemopers',
                name: 'Promemoria',
                component: Promemoria,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'showmemogiust',
                name: 'DaGiustificare',
                component: DaGiustificare,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'showmemogiust',
                name: 'DaGiustificare',
                component: DaGiustificare,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'showpagellapers',
                name: 'Pagella',
                component: Pagella,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'showregistropers',
                name: 'Registro Personale',
                component: RegistroPers,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'showmodrelaz',
                name: 'Mod.Relaz.',
                component: ShowModRel,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'softskillspers',
                name: 'SoftSkillsPers',
                component: IFrame,
                meta: {
                    requiresAuth: true
                },
                props: {
                    //http://swone/AnteprimaSoftSkills.php?param=Y29yc2lkPTExMjE1JnNjaGVtYT1hMjAyMA==
                    //http://ecfoptest.homeip.net/AnteprimaSoftSkills.php?param=corsid=11215&schema=a2020
                    src: 'https://swone.ecfop.it/AnteprimaSoftSkills.php?param='
                }
            },
            {
                path: 'assenze',
                name: 'Assenze',
                component: IFrame,
                meta: {
                    requiresAuth: true
                },
                props: {
                    //http://swone/AnteprimaSoftSkills.php?param=Y29yc2lkPTExMjE1JnNjaGVtYT1hMjAyMA==
                    //http://ecfoptest.homeip.net/AnteprimaSoftSkills.php?param=corsid=11215&schema=a2020
                    src: 'https://swone.cfpcanossa.it/AnteprimaGiustificazioni.php?param='
                }
            },
            {
                path: 'showpagellapershelp',
                name: 'Pagella Help',
                component: PagellaHelp,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'showpuntipers',
                name: 'Punti Pat',
                component: PuntiPat,
                meta: {
                    requiresAuth: true
                },
            },
            ]
        },
        {
            path: '/pages',
            redirect: '/pages/login',
            name: 'Pages',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [{
                path: 'login',
                name: 'Login',
                component: Login
            },
            {
                path: 'chgpass',
                name: 'ChgPass',
                component: ChgPass
            },
            ]
        }
    ]
})
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        var token = sessionStorage.getItem(window.keyname)
        try {
            var OK
            try {
                OK = token && jwt.verify(token, secret)
            } catch (error) {
                OK = false
            }
            OK = token && jwt.verify(token, secret)
            console.log("OK!", OK)
        } catch (e) {
            console.log("OK?", e)
            token = false
        }
        if (!token) {
            next({
                //path: '/pages/login',
                name: 'Login',
                params: {
                    nextUrl: to.fullPath
                }
            })
        } else {
            //console.log("TOKEN:",token)
            next()
        }
    } else {
        next()
    }
})
export default router
